import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import * as XLSX from 'xlsx';

const ILLER = ['Adana','Adıyaman','Afyonkarahisar','Ağrı','Amasya','Ankara','Antalya','Artvin','Aydın','Balıkesir','Bilecik','Bingöl','Bitlis','Bolu','Burdur','Bursa','Çanakkale','Çankırı','Çorum','Denizli','Diyarbakır','Edirne','Elazığ','Erzincan','Erzurum','Eskişehir','Gaziantep','Giresun','Gümüşhane','Hakkari','Hatay','Isparta','Mersin','İstanbul','İzmir','Kars','Kastamonu','Kayseri','Kırklareli','Kırşehir','Kocaeli','Konya','Kütahya','Malatya','Manisa','Kahramanmaraş','Mardin','Muğla','Muş','Nevşehir','Niğde','Ordu','Rize','Sakarya','Samsun','Siirt','Sinop','Sivas','Tekirdağ','Tokat','Trabzon','Tunceli','Şanlıurfa','Uşak','Van','Yozgat','Zonguldak','Aksaray','Bayburt','Karaman','Kırıkkale','Batman','Şırnak','Bartın','Ardahan','Iğdır','Yalova','Karabük','Kilis','Osmaniye','Düzce'];

export default function Arama() {
  const { profil } = useAuth();
  const navigate = useNavigate();
  const isTemsilci = profil?.rol === 'temsilci';

  const [anaTab, setAnaTab] = useState('siparis');
  const [loading, setLoading] = useState(false);
  const [sonuclar, setSonuclar] = useState([]);
  const [firmalar, setFirmalar] = useState([]);
  const [altGruplar, setAltGruplar] = useState({});

  const [sfSehirOneri, setSfSehirOneri] = useState([]);
  const [vfSehirOneri, setVfSehirOneri] = useState([]);
  const [musteriOneri, setMusteriOneri] = useState([]);
  const [vfAdOneri, setVfAdOneri] = useState([]);

  const [sf, setSf] = useState({ siparis_no: '', musteri_adi: '', telefon: '', sehir: '', urun_adi: '', siparis_durumu: '', odeme_durumu: '', fatura_durumu: '', odeme_turu: '', firma_id: '', tarih_bas: '', tarih_bit: '' });
  const [uf, setUf] = useState({ urun_adi: '', firma_id: '', grup: '', tarih_bas: '', tarih_bit: '' });
  const [urunTab, setUrunTab] = useState('ozet');
  const [urunSonuc, setUrunSonuc] = useState(null);
  const [vf, setVf] = useState({ ad: '', telefon: '', sehir: '', ilce: '', musteri_tipi: '' });
  const [vetSonuclar, setVetSonuclar] = useState([]);

  useEffect(() => { fetchFirmalar(); }, []);
  useEffect(() => { if (anaTab === 'siparis') siparisAra(); }, [sf.siparis_no, sf.musteri_adi, sf.telefon, sf.sehir, sf.urun_adi, sf.siparis_durumu, sf.odeme_durumu, sf.fatura_durumu, sf.odeme_turu, sf.firma_id, sf.tarih_bas, sf.tarih_bit, anaTab]);
  useEffect(() => { if (anaTab === 'veteriner') veterinerAra(); }, [vf.ad, vf.telefon, vf.sehir, vf.ilce, vf.musteri_tipi, anaTab]);

  async function fetchFirmalar() {
    const [{ data: f }, { data: u }] = await Promise.all([
      supabase.from('firmalar').select('id, ad').eq('aktif', true),
      supabase.from('urunler').select('firma_id, alt_grup').eq('aktif', true),
    ]);
    setFirmalar(f || []);
    const map = {};
    (u || []).forEach(x => {
      if (!x.firma_id || !x.alt_grup) return;
      if (!map[x.firma_id]) map[x.firma_id] = new Set();
      map[x.firma_id].add(x.alt_grup.trim());
    });
    const sonuc = {};
    Object.keys(map).forEach(k => { sonuc[k] = [...map[k]].sort(); });
    setAltGruplar(sonuc);
  }

  function sfSehirDegisti(val) { setSf(p => ({ ...p, sehir: val })); setSfSehirOneri(val.length >= 1 ? ILLER.filter(il => il.toLowerCase().startsWith(val.toLowerCase())) : []); }
  function vfSehirDegisti(val) { setVf(p => ({ ...p, sehir: val })); setVfSehirOneri(val.length >= 1 ? ILLER.filter(il => il.toLowerCase().startsWith(val.toLowerCase())) : []); }

  async function musteriAdDegisti(val) {
    setSf(p => ({ ...p, musteri_adi: val }));
    if (val.length >= 2) {
      let q = supabase.from('musteriler').select('id, ad').eq('aktif', true).ilike('ad', `${val}%`).limit(8);
      if (isTemsilci) q = q.eq('temsilci_id', profil.id);
      const { data } = await q;
      setMusteriOneri(data || []);
    } else setMusteriOneri([]);
  }

  async function vfAdDegisti(val) {
    setVf(p => ({ ...p, ad: val }));
    if (val.length >= 2) {
      let q = supabase.from('musteriler').select('id, ad').eq('aktif', true).ilike('ad', `${val}%`).limit(8);
      if (isTemsilci) q = q.eq('temsilci_id', profil.id);
      const { data } = await q;
      setVfAdOneri(data || []);
    } else setVfAdOneri([]);
  }

  async function siparisAra() {
    setLoading(true);
    let q = supabase.from('siparisler').select('*, musteriler(ad, telefon, sehir, musteri_tipi), kullanicilar(ad, soyad), firmalar(ad), siparis_kalemleri(urunler(ad))').order('created_at', { ascending: false }).limit(1000);
    if (isTemsilci) q = q.eq('temsilci_id', profil.id);
    if (sf.siparis_no) q = q.ilike('siparis_no', `%${sf.siparis_no}%`);
    if (sf.siparis_durumu) q = q.eq('siparis_durumu', sf.siparis_durumu);
    if (sf.odeme_durumu) q = q.eq('odeme_durumu', sf.odeme_durumu);
    if (sf.odeme_turu) q = q.eq('odeme_turu', sf.odeme_turu);
    if (sf.firma_id) q = q.eq('firma_id', sf.firma_id);
    if (sf.fatura_durumu !== '') q = q.eq('fatura_durumu', sf.fatura_durumu === 'true');
    if (sf.tarih_bas) q = q.gte('created_at', sf.tarih_bas);
    if (sf.tarih_bit) q = q.lte('created_at', sf.tarih_bit + 'T23:59:59');
    let { data } = await q;
    data = data || [];
    if (sf.musteri_adi) data = data.filter(s => s.musteriler?.ad?.toLowerCase().includes(sf.musteri_adi.toLowerCase()));
    if (sf.telefon) data = data.filter(s => (s.musteriler?.telefon || '').includes(sf.telefon));
    if (sf.sehir) data = data.filter(s => (s.musteriler?.sehir || '').toLowerCase().startsWith(sf.sehir.toLowerCase()));
    if (sf.urun_adi) data = data.filter(s => s.siparis_kalemleri?.some(k => k.urunler?.ad?.toLowerCase().includes(sf.urun_adi.toLowerCase())));
    setSonuclar(data);
    setLoading(false);
  }

  async function veterinerAra() {
    setLoading(true);
    let q = supabase.from('musteriler').select('*, kullanicilar(ad, soyad)').eq('aktif', true).order('ad').limit(1000);
    if (isTemsilci) q = q.eq('temsilci_id', profil.id);
    if (vf.musteri_tipi) q = q.eq('musteri_tipi', vf.musteri_tipi);
    let { data } = await q;
    data = data || [];
    if (vf.ad) data = data.filter(m => m.ad.toLowerCase().includes(vf.ad.toLowerCase()));
    if (vf.telefon) data = data.filter(m => (m.telefon || '').includes(vf.telefon));
    if (vf.sehir) data = data.filter(m => (m.sehir || '').toLowerCase().includes(vf.sehir.toLowerCase()));
    if (vf.ilce) data = data.filter(m => (m.ilce || '').toLowerCase().includes(vf.ilce.toLowerCase()));
    setVetSonuclar(data);
    setLoading(false);
  }

  async function urunAra() {
    if (!uf.urun_adi && !uf.firma_id && !uf.grup) { alert('En az bir filtre girin'); return; }
    setLoading(true);
    let { data } = await supabase.from('siparis_kalemleri').select('*, urunler(ad, grup, alt_grup, firma_id, firmalar(ad)), siparisler(siparis_no, created_at, odeme_turu, odeme_durumu, fatura_durumu, kargo_kodu, toplam_komisyon, kullanicilar(ad, soyad), musteriler(ad, sehir, telefon, musteri_tipi))').limit(500);
    data = data || [];
    if (uf.urun_adi) data = data.filter(k => k.urunler?.ad?.toLowerCase().includes(uf.urun_adi.toLowerCase()));
    if (uf.firma_id) data = data.filter(k => k.urunler?.firma_id === uf.firma_id);
    if (uf.grup) data = data.filter(k => (k.urunler?.alt_grup || '').trim() === uf.grup.trim());
    if (uf.tarih_bas) data = data.filter(k => k.siparisler?.created_at >= uf.tarih_bas);
    if (uf.tarih_bit) data = data.filter(k => k.siparisler?.created_at <= uf.tarih_bit + 'T23:59:59');
    const toplamAdet = data.reduce((a, k) => a + (k.miktar || 0), 0);
    const toplamTutar = data.reduce((a, k) => a + (k.toplam || 0), 0);
    const toplamKomisyon = data.reduce((a, k) => a + (k.komisyon_tutari || 0), 0);
    const vetMap = {}; data.forEach(k => { const ad = k.siparisler?.musteriler?.ad || 'Bilinmiyor'; const sehir = k.siparisler?.musteriler?.sehir || '-'; if (!vetMap[ad]) vetMap[ad] = { ad, sehir, adet: 0, tutar: 0, faturali: 0, faturasiz: 0 }; vetMap[ad].adet += k.miktar || 0; vetMap[ad].tutar += k.toplam || 0; if (k.siparisler?.fatura_durumu) vetMap[ad].faturali++; else vetMap[ad].faturasiz++; });
    const gunMap = {}; data.forEach(k => { if (!k.siparisler?.created_at) return; const gun = k.siparisler.created_at.split('T')[0]; if (!gunMap[gun]) gunMap[gun] = { tarih: gun, adet: 0, tutar: 0 }; gunMap[gun].adet += k.miktar || 0; gunMap[gun].tutar += k.toplam || 0; });
    const ayMap = {}; data.forEach(k => { if (!k.siparisler?.created_at) return; const ay = k.siparisler.created_at.substring(0, 7); if (!ayMap[ay]) ayMap[ay] = { ay, adet: 0, tutar: 0 }; ayMap[ay].adet += k.miktar || 0; ayMap[ay].tutar += k.toplam || 0; });
    const sehirMap = {}; data.forEach(k => { const sehir = k.siparisler?.musteriler?.sehir || 'Bilinmiyor'; if (!sehirMap[sehir]) sehirMap[sehir] = { sehir, adet: 0 }; sehirMap[sehir].adet += k.miktar || 0; });
    setUrunSonuc({ kalemler: data, toplamAdet, toplamTutar, toplamKomisyon, vetListesi: Object.values(vetMap).sort((a, b) => b.adet - a.adet), gunluk: Object.values(gunMap).sort((a, b) => a.tarih.localeCompare(b.tarih)), aylik: Object.values(ayMap).sort((a, b) => a.ay.localeCompare(b.ay)), sehirler: Object.values(sehirMap).sort((a, b) => b.adet - a.adet) });
    setLoading(false);
  }

  function siparisExcel() {
    const rows = sonuclar.map(s => ({ 'Sipariş No': s.siparis_no, 'Müşteri': s.musteriler?.ad, 'Telefon': s.musteriler?.telefon, 'Şehir': s.musteriler?.sehir, 'Firma': s.firmalar?.ad, 'Tutar': s.toplam_tutar, 'Durum': s.siparis_durumu, 'Ödeme': s.odeme_durumu, 'Fatura': s.fatura_durumu ? 'Kesildi' : 'Kesilmedi', 'Tarih': new Date(s.created_at).toLocaleDateString('tr-TR') }));
    const ws = XLSX.utils.json_to_sheet(rows); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Siparişler'); XLSX.writeFile(wb, `arama_${new Date().toLocaleDateString('tr-TR').replace(/\./g,'-')}.xlsx`);
  }

  function vetExcel() {
    const rows = vetSonuclar.map(m => ({ 'Ad': m.ad, 'Telefon': m.telefon, 'Şehir': m.sehir, 'İlçe': m.ilce, 'Tip': m.musteri_tipi, 'Temsilci': m.kullanicilar ? `${m.kullanicilar.ad} ${m.kullanicilar.soyad}` : '' }));
    const ws = XLSX.utils.json_to_sheet(rows); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Veterinerler'); XLSX.writeFile(wb, `veterinerler_${new Date().toLocaleDateString('tr-TR').replace(/\./g,'-')}.xlsx`);
  }

  function urunExcel() {
    if (!urunSonuc) return;
    const rows = urunSonuc.kalemler.map(k => ({ 'Ürün': k.urunler?.ad, 'Müşteri': k.siparisler?.musteriler?.ad, 'Şehir': k.siparisler?.musteriler?.sehir, 'Sipariş No': k.siparisler?.siparis_no, 'Miktar': k.miktar, 'Tutar': k.toplam, 'Komisyon': k.komisyon_tutari, 'Fatura': k.siparisler?.fatura_durumu ? 'Kesildi' : 'Kesilmedi', 'Tarih': k.siparisler?.created_at ? new Date(k.siparisler.created_at).toLocaleDateString('tr-TR') : '' }));
    const ws = XLSX.utils.json_to_sheet(rows); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Ürün Analiz'); XLSX.writeFile(wb, `urun_analiz_${new Date().toLocaleDateString('tr-TR').replace(/\./g,'-')}.xlsx`);
  }

  const fmt = v => (v || 0).toLocaleString('tr-TR');
  const durumRenk = { alinidi: 'badge-blue', hazirlaniyor: 'badge-yellow', kargoda: 'badge-orange', teslim: 'badge-green', iade: 'badge-red', iptal: 'badge-gray' };

  function AutoInput({ value, onChange, onSelect, oneri, setOneri, placeholder }) {
    return (
      <div style={{ position: 'relative' }}>
        <input className="input" placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)} onBlur={() => setTimeout(() => setOneri([]), 200)} autoComplete="off" />
        {oneri.length > 0 && (
          <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 'var(--r)', boxShadow: '0 4px 16px rgba(0,0,0,0.12)', zIndex: 100, maxHeight: 200, overflowY: 'auto' }}>
            {oneri.map((item, i) => (
              <div key={i} style={{ padding: '10px 14px', cursor: 'pointer', fontSize: 14, borderBottom: '1px solid var(--border)' }}
                onMouseDown={() => { onSelect(typeof item === 'string' ? item : item.ad); setOneri([]); }}>
                {typeof item === 'string' ? `📍 ${item}` : item.ad}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h1 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>🔍 Gelişmiş Arama</h1>
      </div>

      <div className="tabs" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <button className={`tab-btn ${anaTab === 'siparis' ? 'active' : ''}`} onClick={() => { setAnaTab('siparis'); setSonuclar([]); }}>📦 Sipariş</button>
        <button className={`tab-btn ${anaTab === 'veteriner' ? 'active' : ''}`} onClick={() => { setAnaTab('veteriner'); setSonuclar([]); }}>👨‍⚕️ Müşteri</button>
        <button className={`tab-btn ${anaTab === 'urun' ? 'active' : ''}`} onClick={() => { setAnaTab('urun'); setUrunSonuc(null); }}>🔬 Ürün Analizi</button>
      </div>

      {/* SİPARİŞ ARAMA */}
      {anaTab === 'siparis' && (
        <>
          <div className="card" style={{ marginBottom: 12 }}>
            <div className="form-group">
              <label className="label">Sipariş No</label>
              <input className="input" placeholder="ABC123..." value={sf.siparis_no} onChange={e => setSf(p => ({ ...p, siparis_no: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="label">Müşteri Adı</label>
              <AutoInput value={sf.musteri_adi} onChange={musteriAdDegisti} onSelect={v => setSf(p => ({ ...p, musteri_adi: v }))} oneri={musteriOneri} setOneri={setMusteriOneri} placeholder="İsim yazın..." />
            </div>
            <div className="form-group">
              <label className="label">Telefon</label>
              <input className="input" placeholder="05XX..." value={sf.telefon} onChange={e => setSf(p => ({ ...p, telefon: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="label">Şehir</label>
              <AutoInput value={sf.sehir} onChange={sfSehirDegisti} onSelect={v => { setSf(p => ({ ...p, sehir: v })); setSfSehirOneri([]); }} oneri={sfSehirOneri} setOneri={setSfSehirOneri} placeholder="İstanbul..." />
            </div>
            <div className="form-group">
              <label className="label">Ürün Adı</label>
              <input className="input" placeholder="ONS, TABLET..." value={sf.urun_adi} onChange={e => setSf(p => ({ ...p, urun_adi: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="label">Firma</label>
              <select className="select" value={sf.firma_id} onChange={e => setSf(p => ({ ...p, firma_id: e.target.value }))}>
                <option value="">Tüm Firmalar</option>
                {firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div className="form-group">
                <label className="label">Sipariş Durumu</label>
                <select className="select" value={sf.siparis_durumu} onChange={e => setSf(p => ({ ...p, siparis_durumu: e.target.value }))}>
                  <option value="">Tümü</option>
                  <option value="alinidi">Alındı</option>
                  <option value="hazirlaniyor">Hazırlanıyor</option>
                  <option value="kargoda">Kargoda</option>
                  <option value="teslim">Teslim</option>
                  <option value="iade">İade</option>
                  <option value="iptal">İptal</option>
                </select>
              </div>
              <div className="form-group">
                <label className="label">Ödeme Durumu</label>
                <select className="select" value={sf.odeme_durumu} onChange={e => setSf(p => ({ ...p, odeme_durumu: e.target.value }))}>
                  <option value="">Tümü</option>
                  <option value="odendi">Ödendi</option>
                  <option value="odenmedi">Ödenmedi</option>
                </select>
              </div>
              <div className="form-group">
                <label className="label">Fatura</label>
                <select className="select" value={sf.fatura_durumu} onChange={e => setSf(p => ({ ...p, fatura_durumu: e.target.value }))}>
                  <option value="">Tümü</option>
                  <option value="true">Kesildi</option>
                  <option value="false">Kesilmedi</option>
                </select>
              </div>
              <div className="form-group">
                <label className="label">Ödeme Türü</label>
                <select className="select" value={sf.odeme_turu} onChange={e => setSf(p => ({ ...p, odeme_turu: e.target.value }))}>
                  <option value="">Tümü</option>
                  <option value="banka">Banka</option>
                  <option value="kredi_karti">K. Kartı</option>
                  <option value="elden">Elden</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div className="form-group">
                <label className="label">Başlangıç</label>
                <input type="date" className="input" value={sf.tarih_bas} onChange={e => setSf(p => ({ ...p, tarih_bas: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="label">Bitiş</label>
                <input type="date" className="input" value={sf.tarih_bit} onChange={e => setSf(p => ({ ...p, tarih_bit: e.target.value }))} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
              <button className="btn btn-primary" onClick={siparisAra} disabled={loading} style={{ flex: 1 }}>{loading ? 'Aranıyor...' : '🔍 Ara'}</button>
              <button className="btn btn-ghost" onClick={() => { setSf({ siparis_no: '', musteri_adi: '', telefon: '', sehir: '', urun_adi: '', siparis_durumu: '', odeme_durumu: '', fatura_durumu: '', odeme_turu: '', firma_id: '', tarih_bas: '', tarih_bit: '' }); setSonuclar([]); }}>Temizle</button>
              {sonuclar.length > 0 && <button className="btn btn-ghost btn-sm" onClick={siparisExcel}>📊</button>}
            </div>
          </div>

          {sonuclar.length > 0 && (
            <>
              <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
                <span style={{ padding: '6px 12px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', fontSize: 12 }}><strong>{sonuclar.length}</strong> sipariş</span>
                <span style={{ padding: '6px 12px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', fontSize: 12, color: 'var(--green)' }}><strong>{fmt(sonuclar.reduce((a, s) => a + (s.toplam_tutar || 0), 0))}</strong> ₺</span>
                {!isTemsilci && <span style={{ padding: '6px 12px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', fontSize: 12, color: 'var(--yellow)' }}>Kom: <strong>{fmt(sonuclar.reduce((a, s) => a + (s.toplam_komisyon || 0), 0))}</strong> ₺</span>}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {sonuclar.map(s => (
                  <div key={s.id} onClick={() => navigate(`/siparisler/${s.id}`)} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12, cursor: 'pointer' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span className="mono" style={{ color: 'var(--accent)', fontWeight: 700 }}>{s.siparis_no}</span>
                      <span className={`badge ${durumRenk[s.siparis_durumu]}`}>{s.siparis_durumu}</span>
                    </div>
                    <div style={{ fontWeight: 500, fontSize: 14 }}>{s.musteriler?.ad}</div>
                    <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 4 }}>{s.firmalar?.ad} • {s.musteriler?.sehir}</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontWeight: 700 }}>{fmt(s.toplam_tutar)} ₺</span>
                      <span className={`badge ${s.odeme_durumu === 'odendi' ? 'badge-green' : 'badge-red'}`}>{s.odeme_durumu === 'odendi' ? 'Ödendi' : 'Ödenmedi'}</span>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}

      {/* VETERİNER ARAMA */}
      {anaTab === 'veteriner' && (
        <>
          <div className="card" style={{ marginBottom: 12 }}>
            <div className="form-group">
              <label className="label">Ad / Klinik</label>
              <AutoInput value={vf.ad} onChange={vfAdDegisti} onSelect={v => setVf(p => ({ ...p, ad: v }))} oneri={vfAdOneri} setOneri={setVfAdOneri} placeholder="Veteriner adı..." />
            </div>
            <div className="form-group">
              <label className="label">Telefon</label>
              <input className="input" placeholder="05XX..." value={vf.telefon} onChange={e => setVf(p => ({ ...p, telefon: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="label">Şehir</label>
              <AutoInput value={vf.sehir} onChange={vfSehirDegisti} onSelect={v => { setVf(p => ({ ...p, sehir: v })); setVfSehirOneri([]); }} oneri={vfSehirOneri} setOneri={setVfSehirOneri} placeholder="İstanbul..." />
            </div>
            <div className="form-group">
              <label className="label">İlçe</label>
              <input className="input" placeholder="Kadıköy..." value={vf.ilce} onChange={e => setVf(p => ({ ...p, ilce: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="label">Müşteri Tipi</label>
              <select className="select" value={vf.musteri_tipi} onChange={e => setVf(p => ({ ...p, musteri_tipi: e.target.value }))}>
                <option value="">Tümü</option>
                <option value="faturali_vet">Faturalı Veteriner</option>
                <option value="faturasiz_vet">Faturasız Veteriner</option>
                <option value="bireysel">Bireysel</option>
                <option value="bayi">Bayi</option>
              </select>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-primary" onClick={veterinerAra} disabled={loading} style={{ flex: 1 }}>{loading ? 'Aranıyor...' : '🔍 Ara'}</button>
              <button className="btn btn-ghost" onClick={() => { setVf({ ad: '', telefon: '', sehir: '', ilce: '', musteri_tipi: '' }); setVetSonuclar([]); }}>Temizle</button>
              {vetSonuclar.length > 0 && <button className="btn btn-ghost btn-sm" onClick={vetExcel}>📊</button>}
            </div>
          </div>

          {vetSonuclar.length > 0 && (
            <>
              <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 8 }}><strong>{vetSonuclar.length}</strong> müşteri bulundu</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {vetSonuclar.map(m => (
                  <div key={m.id} onClick={() => navigate(`/musteriler/${m.id}`)} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12, cursor: 'pointer' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span style={{ fontWeight: 600, fontSize: 14 }}>{m.ad}</span>
                      <span className="badge badge-gray" style={{ fontSize: 10 }}>{m.musteri_tipi}</span>
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--text2)' }}>{m.telefon || '-'} • {m.sehir || '-'} {m.ilce ? `/ ${m.ilce}` : ''}</div>
                    {m.kullanicilar && <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 2 }}>Temsilci: {m.kullanicilar.ad} {m.kullanicilar.soyad}</div>}
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}

      {/* ÜRÜN ANALİZİ */}
      {anaTab === 'urun' && (
        <>
          <div className="card" style={{ marginBottom: 12 }}>
            <div className="form-group">
              <label className="label">Ürün Adı</label>
              <input className="input" placeholder="ONS, TABLET..." value={uf.urun_adi} onChange={e => setUf(p => ({ ...p, urun_adi: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="label">Firma</label>
              <select className="select" value={uf.firma_id} onChange={e => setUf(p => ({ ...p, firma_id: e.target.value, grup: '' }))}>
                <option value="">Tüm Firmalar</option>
                {firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="label">Alt Grup</label>
              <select className="select" value={uf.grup} onChange={e => setUf(p => ({ ...p, grup: e.target.value }))} disabled={!uf.firma_id}>
                <option value="">{uf.firma_id ? 'Tüm Alt Gruplar' : 'Önce firma seçin'}</option>
                {uf.firma_id && (altGruplar[uf.firma_id] || []).map(g => <option key={g} value={g}>{g}</option>)}
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div className="form-group">
                <label className="label">Başlangıç</label>
                <input type="date" className="input" value={uf.tarih_bas} onChange={e => setUf(p => ({ ...p, tarih_bas: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="label">Bitiş</label>
                <input type="date" className="input" value={uf.tarih_bit} onChange={e => setUf(p => ({ ...p, tarih_bit: e.target.value }))} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-primary" onClick={urunAra} disabled={loading} style={{ flex: 1 }}>{loading ? 'Analiz ediliyor...' : '🔬 Analiz Et'}</button>
              <button className="btn btn-ghost" onClick={() => { setUf({ urun_adi: '', firma_id: '', grup: '', tarih_bas: '', tarih_bit: '' }); setUrunSonuc(null); }}>Temizle</button>
              {urunSonuc && <button className="btn btn-ghost btn-sm" onClick={urunExcel}>📊</button>}
            </div>
          </div>

          {urunSonuc && (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
                <div className="stat-card"><div className="stat-label">Toplam Adet</div><div className="stat-value" style={{ color: 'var(--accent)' }}>{urunSonuc.toplamAdet}</div></div>
                <div className="stat-card"><div className="stat-label">Toplam Tutar</div><div className="stat-value" style={{ fontSize: 16, color: 'var(--green)' }}>{fmt(urunSonuc.toplamTutar)} ₺</div></div>
                <div className="stat-card" style={{ gridColumn: '1/-1' }}><div className="stat-label">Toplam Komisyon</div><div className="stat-value" style={{ fontSize: 16, color: 'var(--yellow)' }}>{fmt(urunSonuc.toplamKomisyon)} ₺</div></div>
              </div>

              <div className="tabs" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                <button className={`tab-btn ${urunTab === 'ozet' ? 'active' : ''}`} onClick={() => setUrunTab('ozet')}>📊 Grafik</button>
                <button className={`tab-btn ${urunTab === 'veteriner' ? 'active' : ''}`} onClick={() => setUrunTab('veteriner')}>👨‍⚕️ Müşteri</button>
                <button className={`tab-btn ${urunTab === 'tarih' ? 'active' : ''}`} onClick={() => setUrunTab('tarih')}>📅 Tarih</button>
                <button className={`tab-btn ${urunTab === 'detay' ? 'active' : ''}`} onClick={() => setUrunTab('detay')}>📋 Detay</button>
              </div>

              {urunTab === 'ozet' && (
                <div className="card">
                  <h3 style={{ marginBottom: 12, fontWeight: 700, fontSize: 14 }}>Aylık Satış Trendi</h3>
                  {urunSonuc.aylik.length === 0 ? <p style={{ color: 'var(--text2)' }}>Veri yok</p> : (
                    <ResponsiveContainer width="100%" height={180}>
                      <BarChart data={urunSonuc.aylik}>
                        <XAxis dataKey="ay" tick={{ fill: 'var(--text2)', fontSize: 9 }} />
                        <YAxis tick={{ fill: 'var(--text2)', fontSize: 10 }} />
                        <Tooltip formatter={v => v + ' adet'} />
                        <Bar dataKey="adet" fill="#e07b00" radius={[4, 4, 0, 0]} />
                      </BarChart>
                    </ResponsiveContainer>
                  )}
                  <h3 style={{ marginTop: 16, marginBottom: 12, fontWeight: 700, fontSize: 14 }}>Şehir Dağılımı (Top 10)</h3>
                  {urunSonuc.sehirler.length === 0 ? <p style={{ color: 'var(--text2)' }}>Veri yok</p> : (
                    <ResponsiveContainer width="100%" height={180}>
                      <BarChart data={urunSonuc.sehirler.slice(0, 10)} layout="vertical">
                        <XAxis type="number" tick={{ fill: 'var(--text2)', fontSize: 9 }} />
                        <YAxis dataKey="sehir" type="category" tick={{ fill: 'var(--text2)', fontSize: 9 }} width={60} />
                        <Tooltip formatter={v => v + ' adet'} />
                        <Bar dataKey="adet" fill="#3b82f6" radius={[0, 4, 4, 0]} />
                      </BarChart>
                    </ResponsiveContainer>
                  )}
                </div>
              )}

              {urunTab === 'veteriner' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {urunSonuc.vetListesi.map((v, i) => (
                    <div key={i} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 600 }}>{v.ad}</span>
                        <span style={{ color: 'var(--accent)', fontWeight: 700 }}>{v.adet} adet</span>
                      </div>
                      <div style={{ fontSize: 12, color: 'var(--text2)' }}>{v.sehir} • {fmt(v.tutar)} ₺</div>
                    </div>
                  ))}
                </div>
              )}

              {urunTab === 'tarih' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {urunSonuc.aylik.map((a, i) => (
                    <div key={i} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12, display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: 'var(--text2)' }}>{a.ay}</span>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontWeight: 700, color: 'var(--accent)' }}>{a.adet} adet</div>
                        <div style={{ fontSize: 12, color: 'var(--green)' }}>{fmt(a.tutar)} ₺</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {urunTab === 'detay' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {urunSonuc.kalemler.map((k, i) => (
                    <div key={i} onClick={() => navigate(`/siparisler/${k.siparis_id}`)} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12, cursor: 'pointer' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <span style={{ fontWeight: 600, fontSize: 14 }}>{k.urunler?.ad}</span>
                        <span style={{ fontWeight: 700, color: 'var(--accent)' }}>x{k.miktar}</span>
                      </div>
                      <div style={{ fontSize: 12, color: 'var(--text2)' }}>{k.siparisler?.musteriler?.ad} • {k.siparisler?.musteriler?.sehir}</div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
                        <span className="mono" style={{ fontSize: 11, color: 'var(--accent)' }}>{k.siparisler?.siparis_no}</span>
                        <span style={{ fontWeight: 600, color: 'var(--green)', fontSize: 13 }}>{fmt(k.toplam)} ₺</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}
